import { useLogout } from "@/hooks/use-logout";
import { IonIcon, IonItem, IonList } from "@ionic/react";
import { logOut } from "ionicons/icons";

interface MyProfileMenuProps {
  dismissModal?: () => void;
}

const MyProfileMenu = ({ dismissModal }: MyProfileMenuProps) => {
  const { logout } = useLogout();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error("Logout failed:", error);
    } finally {
      dismissModal?.();
    }
  };

  return (
    <IonList>
      <IonItem onClick={handleLogout} className="font-bold">
        <IonIcon
          icon={logOut}
          size="small"
          className="mr-2 text-primary-default"
        />
        Logout
      </IonItem>
    </IonList>
  );
};

export default MyProfileMenu;
